import React from 'react';
import { Slide } from '@material-ui/core';
import Routes from 'routes';
import { registerFromInvitationErrorStep as registerLocales } from 'globals/locales/registration';

import { ReactComponent as ErrorIcon } from 'assets/images/invite-new-user/invite-new-user-error.svg';
import FsAlertBoard from 'ui-elements/alerts/FsAlertBoard';
import { FsStep } from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';

const RegisterFromInvitationErrorStep: React.FC = () => {
  return (
    <Slide direction="left" in timeout={300}>
      <FsStep>
        <FsAlertBoard
          title={registerLocales.title}
          maxWidth={440}
          icon={<ErrorIcon />}
          buttonLabel={registerLocales.buttonLabel}
          url={Routes.LOGIN}
        >
          {registerLocales.description}
        </FsAlertBoard>
      </FsStep>
    </Slide>
  );
};

export default RegisterFromInvitationErrorStep;
